import React from 'react';
export function Footer() {
  return <footer className="py-8 px-5 bg-white text-center text-graphite/60 text-xs" data-id="element-65">
      <p className="mb-4" data-id="element-66">
        © {new Date().getFullYear()} Functional Ready™ — Tutti i Diritti
        Riservati.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-67">
        Questo materiale è destinato esclusivamente a scopi educativi e
        professionali. L'applicazione pratica deve sempre rispettare le
        condizioni individuali dei partecipanti e le linee guida di sicurezza
        appropriate.
      </p>
      <div className="flex justify-center gap-3 font-bold uppercase text-[10px]" data-id="element-68">
        <a href="#" className="hover:text-petrol" data-id="element-69">
          Termini e Condizioni
        </a>
        <span data-id="element-70">·</span>
        <a href="#" className="hover:text-petrol" data-id="element-71">
          Privacy Policy
        </a>
        <span data-id="element-72">·</span>
        <a href="#" className="hover:text-petrol" data-id="element-73">
          Contatti
        </a>
      </div>
    </footer>;
}